import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";

export interface VhsCustomerItem {
    label: string
    customerNumber: string
    id: string
}

class VhsCustomerStore {
    get items(): VhsCustomerItem[] {
        return this._items;
    }

    set items(value: VhsCustomerItem[]) {
        this._items = value;
    }

    private _items: VhsCustomerItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async search(query: string): Promise<VhsCustomerItem[]> {
        const response = await catchApi(async () => api.vhs.api.findCustomers({query: query}))
        return (response?.data || []).map(item => ({
            label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
            customerNumber: `${item.customerNumber}`,
            id: `${item.customerId}`
        }))
    }

    async init() {
        const response = await catchApi(async () => api.vhs.api.findCustomers())
        if (response && response.data) {
            this.items = (response.data || []).map(item => ({
                label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
                customerNumber: `${item.customerNumber}`,
                id: `${item.customerId}`
            }))
        }
    }
}

const vhsCustomerStore = new VhsCustomerStore()

export {
    vhsCustomerStore
}
